<template>
  <div :class="{ 'ali-oss-upload-wrap': true }">
    <todo-list
      v-model="state.uploadFiles"
      :editFormRenderData="uploadConfigsFormRenderData"
      typeTitle="图片"
    >
      <template
        v-slot="{ item, idx, moveIdx, editItem, deleteItem, groupValue }"
      >
        <div class="image-wrap">
          <div class="image-row">
            <el-image
              class="image"
              :preview-src-list="[item.url]"
              :src="item.url"
            ></el-image>
            <div class="btn-wrap">
              <el-icon
                class="icon"
                v-if="idx > 0"
                @click="moveIdx(-1, idx, item)"
              >
                <arrow-up-bold />
              </el-icon>
              <el-icon
                class="icon"
                v-if="idx < groupValue.length - 1"
                @click="moveIdx(1, idx, item)"
              >
                <arrow-down-bold />
              </el-icon>
              <el-icon class="icon" @click="editItem(idx, item)"
                ><edit
              /></el-icon>
              <el-icon class="icon" @click="deleteItem(idx, item)">
                <remove />
              </el-icon>
            </div>
          </div>
        </div>
      </template>
    </todo-list>
  </div>
</template>
<script lang="ts">
import type { UnwrapNestedRefs } from "vue";
import { defineComponent, watch, reactive, ref, onMounted } from "vue";
import type { ExtractPropTypes, SetupContext, PropType, Ref } from "vue";
import { cloneDeep } from "lodash-es";

import { ElMessage } from "element-plus";
import {
  Edit,
  ArrowDownBold,
  ArrowUpBold,
  Remove,
} from "@element-plus/icons-vue";
import type { FormRenderItemConfType } from "quick-vue-components/QuickForm/src/types";
import TodoList from "quick-vue-components/TodoList/src/index";
const AliOssUploadListProps = {
  modelValue: {
    type: Array as PropType<string[]>,
    default: (): string[] => [],
  },
  showStyle: {
    type: String,
    default: "image",
  },
  imageWidth: {
    type: Number,
    default: 100,
  },
  imageHeight: {
    type: Number,
    default: 100,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
};
export type AliOssUploadListType = {
  state: UnwrapNestedRefs<AliOssUploadListStateType>;
  uploadConfigsFormRenderData: FormRenderItemConfType<any>[];
};
export type AliOssUploadListPropsType = ExtractPropTypes<
  typeof AliOssUploadListProps
>;
export type AliOssUploadListStateType = {
  uploadFiles: string[];
};
export default defineComponent({
  name: "AliOssUploadList",
  components: { TodoList, Edit, ArrowDownBold, ArrowUpBold, Remove },
  props: AliOssUploadListProps,

  setup(
    props: AliOssUploadListPropsType,
    ctx: SetupContext
  ): AliOssUploadListType {
    const state: UnwrapNestedRefs<AliOssUploadListStateType> = reactive({
      uploadFiles: cloneDeep(props.modelValue),
    });
    watch(state.uploadFiles, (newVal) => {
      ctx.emit("update:modelValue", newVal);
    });
    watch(
      () => props.modelValue,
      (newVal) => {
        state.uploadFiles = newVal;
      }
    );

    let uploadConfigsFormRenderData: FormRenderItemConfType<any>[] = [
      {
        type: "alisingleupload",
        name: "url",
        layoutCol: 24,
        label: "上传图片",
      },
    ];

    onMounted(() => {});

    return {
      state,
      uploadConfigsFormRenderData,
    };
  },
});
</script>
<style lang="scss" scoped>
.image-wrap {
  display: inline-block;
  margin: 0 5px 5px 0;
  .image-row {
    line-height: 0;
    position: relative;
    .image {
      width: 100px;
      height: 100px;
      border-radius: 5px;
    }
    .btn-wrap {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.3);
      text-align: center;
      padding: 3px 0;
      border-radius: 0px 0px 5px 5px;

      .icon {
        color: #fff;
        font-size: 18px;
        cursor: pointer;
        margin: 0 2px;
      }
    }
  }
}
</style>
